import React from 'react';
import { Modal, Pressable, StyleSheet, View, Text, } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import {  globalStyles, colors } from '../Shared';

interface Props{
    animationType?: 'slide' | 'fade' | 'none';
    transparent?: boolean;
    visible: boolean;
    close: any;
    title: string;
    description: string;
}

export default function SimpleAlert(
    { 
        animationType = 'slide',
        transparent = true,
        visible,
        close,
        title,
        description
     }: Props
){
    const descriptionSplited = description.split('<br>');
    return(
        // <SafeAreaView>
        <Modal
            animationType="fade"
            transparent={transparent}
            visible={visible}
            style={{ flex: 1, flexDirection: 'row',  }}
        >
            <View style={{ flex:1, backgroundColor: '#00000030' }}>
            <Modal
                animationType={animationType}
                transparent={transparent}
                visible={visible}
                style={{ flex: 1, flexDirection: 'row', backgroundColor: 'transparent' }}
            >
                <Pressable style={styles.blankContent} onPress={close}/>
                <View style={styles.container}>
                    <View style={{ width: '100%', maxWidth: 300, marginHorizontal: 'auto' }}>
                        <View style={styles.titleContainer}>
                            <Text style={styles.title}>{title}</Text>
                        </View>
                        
                        <View style={styles.descriptionContainer}>
                        { descriptionSplited.map((item, index) =>
                            <Text style={styles.description} key={index}>
                                {item}
                            </Text>
                        )}
                        </View>

                        <View style={styles.closeContainer}>
                            <Pressable style={styles.closeButton} onPress={close}>
                                <Text style={styles.closeText}>Close</Text>
                            </Pressable>
                        </View>
                    </View>
                </View>

            </Modal>
            </View>
        </Modal>
        // </SafeAreaView>
    );
}

const styles = StyleSheet.create({
    blankContent:{
        flex:1,
        backgroundColor: 'transparent'
    },
    container:{
        width:'100%',
        minHeight: 10,
        paddingTop: 20,
        paddingBottom:30,
        paddingHorizontal: 20,
        backgroundColor: '#fff',
        flexDirection: 'column',
    },
    titleContainer:{
        paddingBottom: 10
    },
    title:{
        fontSize: 28
    },
    descriptionContainer:{
        paddingTop: 2,
        fontWeight: '500'
    },
    description:{
        fontSize: 14
    },
    closeContainer:{
        paddingTop: 20,
        paddingBottom: 5,
    },
    closeButton:{
        backgroundColor: colors.bg.primary,
        borderRadius: 8,
        height: 50,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
        // ...globalStyles.centerFlex
    },
    closeText:{
        fontSize: 18,
        color: '#fff'
    }
});